/**
 * Created by pajicv on 11/5/18.
 */

const firebaseProjects = {
  FIREBASE_PROJECT_UX_AUTUMN: 'uxs-autumn',
  FIREBASE_PROJECT_SECONDARY: 'cx-project-2'
};

//export const FIREBASE_PROJECT_ID = firebaseProjects.FIREBASE_PROJECT_UX_AUTUMN;
 export const FIREBASE_PROJECT_ID = firebaseProjects.FIREBASE_PROJECT_SECONDARY;

export const MAIN_COLOR = FIREBASE_PROJECT_ID === firebaseProjects.FIREBASE_PROJECT_UX_AUTUMN ? '#dc002c' : '#5d52a3';

export const LOGO = FIREBASE_PROJECT_ID === firebaseProjects.FIREBASE_PROJECT_UX_AUTUMN ? '../../logoUX.png' : '../../cy-x_logo.png';

export const APP_URL = FIREBASE_PROJECT_ID === firebaseProjects.FIREBASE_PROJECT_UX_AUTUMN ? 'cycue.com' : 'uxsuite.cyledge.com';

export const colors = {
  black: '#111111',
  darkgrey: '#545A68',
  lightgrey: '#c2cad0',
  green: '#54be89',
  yellow: '#e7ba3b',
  orange: '#ef6920'
};

export default () => {
  switch (FIREBASE_PROJECT_ID) {
    case firebaseProjects.FIREBASE_PROJECT_UX_AUTUMN: {
      return {
        apiKey: 'AIzaSyAHzostrTWLHU17bYMjAz4HcgfNALIxiBk',
        authDomain: 'uxs-autumn.firebaseapp.com',
        databaseURL: 'https://uxs-autumn.firebaseio.com',
        projectId: 'uxs-autumn',
        storageBucket: 'uxs-autumn.appspot.com',
        messagingSenderId: '753913472019'
      };
    }
    case firebaseProjects.FIREBASE_PROJECT_SECONDARY: {
      return {
        apiKey: 'AIzaSyCOky9pxqTTpGej6ZTrtzk25bE1bbFxVr4',
        authDomain: 'cx-project-2.firebaseapp.com',
        databaseURL: 'https://cx-project-2.firebaseio.com',
        projectId: 'cx-project-2',
        storageBucket: "cx-project-2.appspot.com",
        messagingSenderId: '428255394096'
      };
    }
    default: {
      return {
        apiKey: 'AIzaSyAHzostrTWLHU17bYMjAz4HcgfNALIxiBk',
        authDomain: 'uxs-autumn.firebaseapp.com',
        databaseURL: 'https://uxs-autumn.firebaseio.com',
        projectId: 'uxs-autumn',
        storageBucket: 'uxs-autumn.appspot.com',
        messagingSenderId: '753913472019'
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/firebase-config.js